/*
  "Yes, send me an A4 sample" switch for an option with a sample value (wallpaper: Type = Custom size /
  A4 sample). The switch is a button, not an input: variant-selects reads every checked input in its
  fieldsets. Turning it on or off checks the matching hidden radio, so variant-selects swaps the variant,
  and enables the "Sample kit" line item property only while it is on.
  Markup: snippets/product-variant-picker.liquid.
*/
if (!customElements.get('pdp-sample-switch')) {
  customElements.define(
    'pdp-sample-switch',
    class PdpSampleSwitch extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-sample-switch]');
        this.onClick = this.onClick.bind(this);
        this.button?.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onClick);
      }

      onClick() {
        const turnOn = this.button.getAttribute('aria-checked') !== 'true';
        const radio = this.querySelector(`input[data-sample-value="${turnOn ? 'sample' : 'regular'}"]`);
        if (!radio) return;

        this.button.setAttribute('aria-checked', String(turnOn));
        const kit = this.querySelector('[data-sample-kit]');
        if (kit) kit.disabled = !turnOn;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  );
}
